const isTestCafeEnabled = () =>
  import.meta.env.VITE_APP_API_BASE_TESTCAFE_URL &&
  sessionStorage.getItem('X-TestCafe') === 'hzQuVvBzsam9pGFdqUNCuTUS99zGu84bG'

export default isTestCafeEnabled
